<template lang="html">

    <div>

        <h2>{{$t('guias.titulo')}}</h2>

        <section class="listado-eventos container row-between">


            <div class="container">
  
                <template v-if="guiasOrientacion.length != 0">
                  <guia-orientacion :key="key" :data="guia" v-for="(guia,key) in guiasOrientacion.slice(0,4)"></guia-orientacion>
                </template>
          
                <p v-else>{{$t('guias.zero')}}</p>
          
              </div>
          


        </section>


    </div>

</template>

<script lang="js">

    import { mapGetters,mapActions } from 'vuex';

    import guiaorientacion from '@/components/parts/guia-orientacion'


    export default {
        name: 'modulo-guias',
        mounted() {
            this.requestGuiasOrientacion();
        },
        components: {
            'guia-orientacion': guiaorientacion
        },
        methods: {
            ...mapActions([
                'requestGuiasOrientacion'
            ])
        },
        computed: {
            ...mapGetters({
                guiasOrientacion: 'getGuiasOrientacion'
            })
        }
    }
</script>

<style scoped lang="scss">
    h2 {
        font-weight: 800;
        width: 100%;
        font-size: 36px;
        margin-bottom: 50px;
    }

    @media screen and (max-width: 500px) {
        h2 {
            font-size: 24px;
            margin-bottom: 15px;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/views/home/modulo-guias.vue